import { Component, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { TopgradserviceService } from '../../../topgradservice.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {HttpResponseCode} from '../../../shared/enum';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DomSanitizer } from '@angular/platform-browser';
import { EventEmitter } from 'stream';

@Component({
  selector: 'app-send-email-popup',
  templateUrl: './send-email-popup.component.html',
  styleUrls: ['./send-email-popup.component.scss']
})
export class SendEmailPopupComponent implements OnInit {
  modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],                                   
      ['link']   
    ]
  };
  // @Output() emailSent = new EventEmitter(); // EventEmitter for callback
  @Input() modalId: string;
  @Input() type: string;
  @Input() title?: string;
  @Input() titleChange?: boolean ;
  @ViewChild('closeSendEmailModal') closeSendEmailModal;
  @ViewChild('emailPreviewModal1') public emailPreviewModal1: ModalDirective;
  @ViewChild('emailPlaceholder') public emailPlaceholder: ModalDirective;
  @ViewChild('sendDone') public sendDone: ModalDirective;
  
  editorConfig = {
    height: 200,
    menubar: false,
    statusbar: true,
    placeholder: 'Email content',
    plugins: 'linkchecker wordcount table  autosave advlist anchor image link lists media searchreplace visualblocks template',
    toolbar: 'undo redo | bold italic underline | align bullist numlist | blocks | image | placeHolderToken',
    contextmenu: false,
    setup: function (editor) {
      editor.ui.registry.addMenuButton('placeHolderToken', {
        text: '{{...}}',
        fetch: (callback) => {
          const items = [
            {
              type: 'nestedmenuitem',
              text: 'Student',
              getSubmenuItems: () => [
                {
                  type: 'menuitem',
                  text: 'Name',
                  onAction: (_) => editor.insertContent("[[name]]")
                },
                {
                  type: 'menuitem',
                  text: 'Email',
                  onAction: (_) => editor.insertContent("[[email]]")
                },
                {
                  type: 'menuitem',
                  text: 'Password',
                  onAction: (_) => editor.insertContent("[[password]]")
                },
                {
                  type: 'menuitem',
                  text: 'First Name',
                  onAction: (_) => editor.insertContent("[[first_name]]")
                },
                {
                  type: 'menuitem',
                  text: 'Last Name',
                  onAction: (_) => editor.insertContent("[[last_name]]")
                }
              ]
            }
          ];
          callback(items);
        }
      });
    }
  }
  categories = [];
  emailTemplateList = [];
  emailForm: FormGroup;
  @Input() emailType;
  @Input() students;
  selectedTemplate = null;
  
  constructor(private service: TopgradserviceService, private fb: FormBuilder, 
    private sanitizer: DomSanitizer) {
     }

  ngOnInit(): void {
  //   this.getEmailCategories();
  //   this.emailForm = this.fb.group({
  //     category_id: ['', [Validators.required]],
  //     template_id: ['', [Validators.required]],
  //     subject: ['', [Validators.required]],
  //     message:  ['',  [Validators.nullValidator]]
  //   });

  console.log("student", this.students, this.emailType);
  }

  ngOnChanges() {
 
    this.getEmailCategories();
    this.emailForm = this.fb.group({
      category_id: ['', [Validators.required]],
      template_id: ['', [Validators.required]],
      subject: ['', [Validators.required]],
      message:  ['',  [Validators.nullValidator]]
    });
    console.log("student", this.students, this.emailType);
  }

  getEmailCategories() {
    this.service.getEmailTemplateCategories().subscribe((response: any) => { 
      this.categories = response.data;
    });
  }

  selectCategory(event) {
    const payload = {
      category_id: event
    }
    this.service.getEmailTemplateByCategoryId(payload).subscribe((response: any) => { 
      this.emailTemplateList = response.result;
    });
  }

  selectTemplate(event) {
    const foundTemplate = this.emailTemplateList.find(template => template._id === event);
    if (foundTemplate) {
      this.emailForm.patchValue({
        subject: foundTemplate?.subject,
        message: foundTemplate?.message
      });
      this.selectedTemplate = foundTemplate;
      this.selectedTemplate.widget = this.sanitizer.bypassSecurityTrustHtml(foundTemplate.widgets.html);
    }
  }

  cancelEmail() {
    this.emailForm.reset();
  }

  sendEmail() {
    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
      return;
    }
    let payload: any = {
      subject: this.emailForm.value.subject,
      category_id: this.emailForm.value.category_id,
      template_id: this.emailForm.value.template_id,
      student_ids: this.students.map(student => student._id ?? student.student_id),
      message: this.emailForm.value.message,
      type: this.emailType,
      receiver_type:this.type,
      email_id: this.students.map(student => student.email_id).join()
    }

    if (this.emailType === 'remindEmployer') {
      payload['email_id'] = this.students[0].contact_01_primary_email;
      payload['contact_primary_email'] = this.students[0].contact_01_primary_email;
      payload['contact_primary_phone'] = this.students[0].contact_01_primary_phone;
      payload['contact_secondary_phone'] = this.students[0].contact_01_secondary_phone;
      payload['contact_secondary_email'] = this.students[0].contact_01secondary_email;
      payload['receiver_type'] =this.type;
    }

    if (this.emailType === 'vacancy') {
      payload = { 
        email_id: this.students.map(vacancy => vacancy.company_info[0].contact_01_primary_email).join(),
        // category_id: this.emailForm.value.category_id,
        company_id: this.students[0].company_info[0]?._id,
        template_id: this.emailForm.value.template_id,
        subject: this.emailForm.value.subject,
        message: this.emailForm.value.message,
        receiver_type:this.type,
      };
    }

    if (this.emailType === 'placement_company') {
      payload = { 
        email_id: this.students.map(company => company.email).join(),
        category_id: this.emailForm.value.category_id,
        company_id: this.students[0].company_id,
        template_id: this.emailForm.value.template_id,
        subject: this.emailForm.value.subject,
        message: this.emailForm.value.message,
        receiver_type:this.type,
      };
    }

    if (this.students[0].eType === 'company_student') {
      payload = { 
        email_id: this.students.map(company => company.email).join(),
        category_id: this.emailForm.value.category_id,
        company_id: this.students[0].company_id,
        template_id: this.emailForm.value.template_id,
        subject: this.emailForm.value.subject,
        message: this.emailForm.value.message,
        type: this.students[0].eType
      };
    }



    if (this.emailType === 'company') {
      payload = { 
        email_id: this.students.map(company => company.email).join(),
        category_id: this.emailForm.value.category_id,
        company_id: this.students[0].company_id,
        template_id: this.emailForm.value.template_id,
        subject: this.emailForm.value.subject,
        message: this.emailForm.value.message,
        receiver_type:this.type,
      };
    }

    if (this.emailType === 'users') {
      payload = { 
        email_id: this.students.map(student => student.email).join(),
        category_id: this.emailForm.value.category_id,
        template_id: this.emailForm.value.template_id,
        subject: this.emailForm.value.subject,
        message: this.emailForm.value.message,
        receiver_type:this.type,
      };
    }
    
    this.service.sendEmail(payload).subscribe((res: any) => {
      this.emailForm.reset();
      // this.emailSent.emit({ success: true, message: "Email sent successfully!" });
      this.emailPlaceholder.hide()
      this.closeSendEmailModal.ripple.trigger.click();
      this.sendDone.show();
      if (res.status == HttpResponseCode.SUCCESS) {
        this.service.showMessage({
          message:"Email sent successfully"
        });        
      }
     
    }, err => {
      this.service.showMessage({
        message: err.msg ? err.msg : 'Something went Wrong'
      });
    });
  }
  openEmailPreviewModal() {
    this.emailPreviewModal1.show();
  }

  closeEmailPreviewModal() {
    this.emailPreviewModal1.hide();
  }
}
